import React from 'react';

/**
 * CustomersCards - Card grid view for customer list
 * Shows: name, status, address, city, contact, phone, email
 */
const CustomersCards = ({
  customers,
  isAdmin,
  onView,
  onEdit,
  onDelete
}) => {
  const stop = (e) => e.stopPropagation();

  return (
    <div className="customers-cards-container">
      {customers.map(customer => (
        <div
          key={customer.id}
          className="customer-card clickable-card"
          onClick={() => onView(customer)}
        >
          <div className="card-header">
            <h3 className="card-title">{customer.name}</h3>
            <span className={`status-badge ${customer.status}`}>
              {customer.status}
            </span>
          </div>
          <div className="card-body">
            <div className="card-details">
              <div className="card-detail-item">
                <span className="detail-label">Address:</span>
                <span className="detail-value">{customer.address}</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">City:</span>
                <span className="detail-value">{customer.city}, {customer.state} {customer.zip}</span>
              </div>
              {customer.contact_person && (
                <div className="card-detail-item">
                  <span className="detail-label">Contact:</span>
                  <span className="detail-value">{customer.contact_person}</span>
                </div>
              )}
              {customer.phone && (
                <div className="card-detail-item">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">{customer.phone}</span>
                </div>
              )}
              {customer.email && (
                <div className="card-detail-item">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">{customer.email}</span>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer" onClick={stop}>
            {isAdmin ? (
              <>
                <button className="card-action-btn view" onClick={() => onView(customer)}>
                  View
                </button>
                <button className="card-action-btn edit" onClick={() => onEdit(customer)}>
                  Edit
                </button>
                <button className="card-action-btn delete" onClick={() => onDelete(customer)}>
                  Delete
                </button>
              </>
            ) : (
              <button className="card-action-btn view" onClick={() => onView(customer)}>
                View
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomersCards;
